var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M46.7614 23.9998C46.7614 36.5707 36.5707 46.7614 23.9998 46.7614C11.429 46.7614 1.23828 36.5707 1.23828 23.9998C1.23828 11.429 11.429 1.23828 23.9998 1.23828C36.5707 1.23828 46.7614 11.429 46.7614 23.9998Z","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M27.2862 16.875H13.3662V29.9827H26.1047L31.0154 34.0812V29.9827H34.7077V16.875H32.197","strokeMiterlimit":"10","key":1})]);
}

Chat.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Chat;

Chat.default = Chat;
